import { render, staticRenderFns } from "./remote_data.vue?vue&type=template&id=7436bfde"
import script from "./remote_data.vue?vue&type=script&lang=js"
export * from "./remote_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports